import dayjs from 'dayjs'
import { Colors } from '~/styles/colors'
import { TypePressReleaseArticles } from '~/types/contentful'

type NextArticleProps = {
  entry: TypePressReleaseArticles<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export default function NextArticle({ entry }: NextArticleProps) {
  const openArticle = (pageUrl: string) => {
    window.location.href = `/press/article/${pageUrl}`
  }

  return (
    <div className="flex flex-col gap-1 mt-24 max-lg:mt-16 max-md:mt-12">
      <span className="text-xs pb-3">Next Article</span>
      <div
        className="flex flex-col gap-6 p-6 rounded-3xl max-md:p-4 max-md:gap-3 hover:cursor-pointer hover:bg-neutral-5"
        onClick={() => openArticle(entry?.fields?.pageUrl as string)}
      >
        {entry?.fields?.brandLogo?.fields?.file?.url && (
          <img
            className="object-contain w-fit h-5 max-w-25"
            src={entry?.fields?.brandLogo?.fields?.file?.url}
            alt={entry?.fields?.brandLogo?.fields?.title}
          />
        )}

        <h1 className="text-l text-neutral-100">{entry?.fields?.pageTitle}</h1>

        <div className="flex gap-3 items-center whitespace-nowrap">
          <span className="text-xs text-neutral-60">
            {dayjs(entry?.fields?.datePublished).format('MMMM DD, YYYY')}
          </span>
        </div>
      </div>
      <div style={{ borderBottom: `1px solid ${Colors.Neutral15}` }} />
    </div>
  )
}
